"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormCheckbox = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["id", "children", "className", "alignMiddle"];
var FormCheckbox = exports.FormCheckbox = function FormCheckbox(_ref) {
  var id = _ref.id,
    children = _ref.children,
    className = _ref.className,
    _ref$alignMiddle = _ref.alignMiddle,
    alignMiddle = _ref$alignMiddle === void 0 ? false : _ref$alignMiddle,
    inputProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var elementClasses = (0, _classnames["default"])('form-checkbox', className, {
    'form-checkbox_align-middle': alignMiddle
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: elementClasses
  }, /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    id: id,
    className: "form-checkbox__input"
  }, inputProps, {
    type: "checkbox"
  })), /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id,
    className: "form-checkbox__label"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "form-checkbox__icon"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    className: "form-checkbox__icon_checked",
    width: "12",
    height: "10",
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.99948 5.88046L9.58548 0.294461C9.78148 0.0984609 10.0975 0.0984609 10.2935 0.294461L11.7075 1.70846C11.9025 1.90346 11.9025 2.22046 11.7075 2.41546L4.35348 9.76846C4.15848 9.96446 3.84148 9.96446 3.64648 9.76846L0.293484 6.41546C0.0974844 6.22046 0.0974844 5.90346 0.293484 5.70846L1.70748 4.29446C1.90248 4.09846 2.21948 4.09846 2.41448 4.29446L3.99948 5.87946V5.88046Z",
    fill: "currentColor"
  }))), children));
};

// is only needed to avoid snapshots updating
FormCheckbox.defaultProps = {
  alignMiddle: false
};